<script>
    import Layout from "../../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Loader from "../../../../components/widgets/loader";
    import Forms from "../../../../mixins/Forms";

    import axios from 'axios';

    /**
     * View users component
     */
    export default {
        page: {
            title: "All Users",
            meta: [{name: "description", content: appConfig.description}]
        },
        mixins: [Forms],
        components: {Layout, PageHeader, Loader},
        data() {
            return {
                title: "All Users",
                items: [
                    {
                        text: "Settings",
                        href: "#"
                    },
                    {
                        text: "All Users",
                        active: true
                    }
                ],

                isLoading: false,
                users: null,
                serverErrors: []
            };
        },
        methods: {
            loadUsers() {
                let vm = this;
                vm.isLoading = true;

                vm.isSaving = true;
                axios.get(API_BASE + '/users/').then(r => {
                    vm.isLoading = false;
                    vm.users = r.data;
                }).catch(e => {
                    console.log(e);
                    vm.isLoading = false;
                    vm.setErrors(e);
                });
            }
        },
        created() {
            this.loadUsers();
        }
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <errors :error-list="serverErrors"></errors>

        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="isLoading" class="text-center">
                            <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
                        </div>

                        <div v-if="!isLoading" class="table-responsive mb-0">
                            <table class="table mb-0 table-centered">
                                <thead class="thead-light">
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="user in users">
                                    <th scope="row">{{ user.id }}</th>
                                    <td>{{ user.name }}</td>
                                    <td>{{ user.email }}</td>
                                    <td class="text-right">
                                        <!-- Button trigger modal -->
                                        <button
                                                type="button"
                                                class="btn btn-itg btn-sm"
                                                @click="$router.push('/settings/users/'+user.id+'/edit')"
                                        >
                                            Edit
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="users.length === 0">
                                    <th scope="row" colspan="4">
                                        <span class="text-danger">No results</span>
                                    </th>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>
